export default __webpack_public_path__ + "static/east-main-video1-3f8bd694c4e79e0124ecff6302bc4dcd.jpg";